import SUCCESS_MESSAGE from "constants/successMessage";
import handleErrorMessageAPI from "global/AlertErrorMessage";
import setting from "lib/api/setting";
import create from "zustand";
import { ResponseFormats } from "../../../../@types/api-response";
import { UpdateEmail, ConfirmOTP } from "./store.types";

interface ChangeEmailSlice {
  changeToken: string | null;
  email: string | null;
  isLoading: boolean;
  getEmailToken: (password: string) => Promise<ResponseFormats>;
  updateEmail: (param: UpdateEmail) => Promise<ResponseFormats>;
  confirmOTP: (param: ConfirmOTP) => Promise<ResponseFormats>;
  resendOTP: () => Promise<ResponseFormats>;
}

const changeEmailStore = create<ChangeEmailSlice>((set, get) => ({
  changeToken: null,
  isLoading: false,
  email: null,
  getEmailToken: async (password) => {
    set({ isLoading: true });

    try {
      const data = {
        type: "CHANGE_TOKEN_TYPE_EMAIL",
        req_type: "CHANGE_TOKEN_REQ_TYPE_EDIT",
        password,
      };

      const res = await setting.getChangePasswordToken(data);

      if (!res.data) {
        throw new Error("Attempt to get change token failed");
      }

      const { data: response, error, error_type, message } = res.data;

      if (error_type || error) {
        throw new Error(message);
      }

      set({ changeToken: response.change_token, isLoading: false });

      return { data, message };
    } catch (e) {
      set({ isLoading: false });
    }
  },
  updateEmail: async (params) => {
    set({ isLoading: true });
    try {
      const res = await setting.updateEmail(params);

      if (!res.data) {
        throw new Error("Attempt to update email failed");
      }

      const { data, error, error_type, message } = res.data;

      if (error_type || error) {
        throw new Error(message);
      }

      handleErrorMessageAPI(message, SUCCESS_MESSAGE.ALERT_GREEN);
      set({ isLoading: false, email: params.email });

      return { data: "Success", message };
    } catch (e) {
      set({ isLoading: false });
    }
  },
  confirmOTP: async (params) => {
    set({ isLoading: true });
    try {
      const res = await setting.confirmEmailOTP(params);

      if (!res.data) {
        throw new Error("Attempt to confirm email OTP failed");
      }

      const { data, error, error_type, message } = res.data;

      if (error_type || error) {
        throw new Error(message);
      }

      handleErrorMessageAPI(message, SUCCESS_MESSAGE.ALERT_GREEN);
      set({ isLoading: false });
      return { data: data || "Success", message };
    } catch (e) {
      set({ isLoading: false });
    }
  },
  resendOTP: async () => {
    const { email, changeToken, updateEmail } = get();
    const params = {
      change_token: changeToken,
      email,
    };

    return await updateEmail(params);
  },
}));

export default changeEmailStore;
